export default {
    token: null,
    isLoggedIn: false 
}